// Balok Bentuk Pintar - Block Puzzle Educational Game Data

// Shape definitions using SVG paths
import { logger } from "./logger";
import { getVoiceLang } from "./voicePref";
export const SHAPES = {
  circle: { name: "Lingkaran", path: "M50,10 A40,40 0 1,1 50,90 A40,40 0 1,1 50,10 Z" },
  triangle: { name: "Segitiga", path: "M50,10 L90,90 L10,90 Z" },
  square: { name: "Persegi", path: "M15,15 L85,15 L85,85 L15,85 Z" },
  oval: { name: "Oval", path: "M50,15 A35,30 0 1,1 50,85 A35,30 0 1,1 50,15 Z" },
  diamond: { name: "Belah Ketupat", path: "M50,10 L90,50 L50,90 L10,50 Z" },
  star: { name: "Bintang", path: "M50,10 L61,38 L90,38 L67,56 L76,85 L50,68 L24,85 L33,56 L10,38 L39,38 Z" },
  heart: { name: "Hati", path: "M50,85 C20,60 5,40 15,25 C25,10 40,15 50,30 C60,15 75,10 85,25 C95,40 80,60 50,85 Z" },
  hexagon: { name: "Segi Enam", path: "M50,10 L85,30 L85,70 L50,90 L15,70 L15,30 Z" },
};

export const COLORS = {
  red: { name: "Merah", hex: "#EF4444", light: "#FCA5A5" },
  blue: { name: "Biru", hex: "#3B82F6", light: "#93C5FD" },
  green: { name: "Hijau", hex: "#22C55E", light: "#86EFAC" },
  yellow: { name: "Kuning", hex: "#EAB308", light: "#FDE047" },
  purple: { name: "Ungu", hex: "#A855F7", light: "#D8B4FE" },
  orange: { name: "Oranye", hex: "#F97316", light: "#FDBA74" },
  pink: { name: "Pink", hex: "#EC4899", light: "#F9A8D4" },
  cyan: { name: "Biru Muda", hex: "#06B6D4", light: "#67E8F9" },
};

export const BLOCK_LEVELS = [
  {
    id: 1,
    name: "Cocokkan Bentuk",
    icon: "🔷",
    color: "#3B82F6",
    desc: "Taruh bentuk ke bayangan yang cocok!",
    type: "match_shape",
    questions: [
      { targets: ["circle", "square", "triangle"], pool: ["circle", "square", "triangle", "diamond"] },
      { targets: ["star", "oval", "diamond"], pool: ["star", "oval", "diamond", "heart"] },
      { targets: ["hexagon", "heart", "circle"], pool: ["hexagon", "heart", "circle", "triangle"] },
      { targets: ["square", "diamond", "star"], pool: ["square", "diamond", "star", "oval"] },
      { targets: ["triangle", "circle", "heart", "square"], pool: ["triangle", "circle", "heart", "square", "diamond"] },
    ],
  },
  {
    id: 2,
    name: "Cocokkan Warna",
    icon: "🎨",
    color: "#EF4444",
    desc: "Taruh balok ke slot warna yang sama!",
    type: "match_color",
    questions: [
      { targets: ["red", "blue", "green"], pool: ["red", "blue", "green", "yellow"] },
      { targets: ["purple", "orange", "yellow"], pool: ["purple", "orange", "yellow", "pink"] },
      { targets: ["cyan", "pink", "red", "blue"], pool: ["cyan", "pink", "red", "blue", "green"] },
      { targets: ["green", "purple", "orange"], pool: ["green", "purple", "orange", "cyan"] },
      { targets: ["yellow", "red", "blue", "pink"], pool: ["yellow", "red", "blue", "pink", "purple"] },
    ],
  },
  {
    id: 3,
    name: "Susun Pola",
    icon: "🔄",
    color: "#A855F7",
    desc: "Lanjutkan pola yang benar!",
    type: "pattern",
    questions: [
      { pattern: ["red", "blue", "red", "blue", "red"], answer: "blue", options: ["red", "blue", "green", "yellow"] },
      { pattern: ["circle", "square", "circle", "square", "circle"], answer: "square", options: ["circle", "square", "triangle", "diamond"] },
      { pattern: ["green", "green", "yellow", "green", "green"], answer: "yellow", options: ["green", "yellow", "red", "blue"] },
      { pattern: ["triangle", "triangle", "circle", "triangle", "triangle"], answer: "circle", options: ["triangle", "circle", "square", "star"] },
      { pattern: ["red", "blue", "green", "red", "blue"], answer: "green", options: ["red", "blue", "green", "purple"] },
      { pattern: ["star", "heart", "star", "heart", "star"], answer: "heart", options: ["star", "heart", "diamond", "circle"] },
    ],
  },
  {
    id: 4,
    name: "Puzzle Gambar",
    icon: "🏠",
    color: "#F97316",
    desc: "Susun balok jadi gambar utuh!",
    type: "picture_puzzle",
    questions: [
      {
        name: "Rumah", gridSize: 3, pieces: [
          { pos: [0,0], color: "#3B82F6", label: "🌤" },
          { pos: [0,1], color: "#EF4444", label: "🔺" },
          { pos: [0,2], color: "#3B82F6", label: "🌤" },
          { pos: [1,0], color: "#A855F7", label: "🟪" },
          { pos: [1,1], color: "#F97316", label: "🚪" },
          { pos: [1,2], color: "#A855F7", label: "🟪" },
          { pos: [2,0], color: "#22C55E", label: "🌿" },
          { pos: [2,1], color: "#22C55E", label: "🌿" },
          { pos: [2,2], color: "#22C55E", label: "🌿" },
        ],
      },
      {
        name: "Pohon", gridSize: 3, pieces: [
          { pos: [0,0], color: "#22C55E", label: "🍃" },
          { pos: [0,1], color: "#22C55E", label: "🌿" },
          { pos: [0,2], color: "#22C55E", label: "🍃" },
          { pos: [1,0], color: "#22C55E", label: "🍃" },
          { pos: [1,1], color: "#22C55E", label: "🌳" },
          { pos: [1,2], color: "#22C55E", label: "🍃" },
          { pos: [2,0], color: "#EAB308", label: "🟫" },
          { pos: [2,1], color: "#92400E", label: "🪵" },
          { pos: [2,2], color: "#EAB308", label: "🟫" },
        ],
      },
      {
        name: "Matahari", gridSize: 3, pieces: [
          { pos: [0,0], color: "#F97316", label: "☀" },
          { pos: [0,1], color: "#EAB308", label: "✨" },
          { pos: [0,2], color: "#F97316", label: "☀" },
          { pos: [1,0], color: "#EAB308", label: "✨" },
          { pos: [1,1], color: "#EF4444", label: "🔴" },
          { pos: [1,2], color: "#EAB308", label: "✨" },
          { pos: [2,0], color: "#F97316", label: "☀" },
          { pos: [2,1], color: "#EAB308", label: "✨" },
          { pos: [2,2], color: "#F97316", label: "☀" },
        ],
      },
    ],
  },
  {
    id: 5,
    name: "Bentuk Kompleks",
    icon: "🧩",
    color: "#10B981",
    desc: "Gabungkan potongan jadi bentuk utuh!",
    type: "composite",
    questions: [
      { target: "square", parts: ["triangle", "triangle"], hint: "Dua segitiga = satu persegi!" },
      { target: "diamond", parts: ["triangle", "triangle"], hint: "Dua segitiga terbalik = belah ketupat!" },
      { target: "hexagon", parts: ["triangle", "triangle", "triangle", "triangle", "triangle", "triangle"], hint: "Enam segitiga = segi enam!" },
      { target: "heart", parts: ["circle", "circle", "triangle"], hint: "Dua lingkaran + segitiga = hati!" },
      { target: "star", parts: ["triangle", "triangle", "triangle", "triangle", "triangle"], hint: "Lima segitiga = bintang!" },
    ],
  },
  {
    id: 6,
    name: "Mode Tantangan",
    icon: "⚡",
    color: "#EAB308",
    desc: "Cocokkan bentuk dengan waktu santai!",
    type: "speed",
    timePerQuestion: 12,
    questions: [
      { type: "shape", target: "circle", options: ["circle", "square", "triangle", "diamond"] },
      { type: "color", target: "red", options: ["red", "blue", "green", "yellow"] },
      { type: "shape", target: "star", options: ["star", "heart", "oval", "hexagon"] },
      { type: "color", target: "blue", options: ["purple", "blue", "cyan", "green"] },
      { type: "shape", target: "triangle", options: ["circle", "triangle", "square", "diamond"] },
      { type: "color", target: "green", options: ["yellow", "red", "green", "orange"] },
      { type: "shape", target: "heart", options: ["heart", "circle", "oval", "star"] },
      { type: "color", target: "purple", options: ["pink", "purple", "blue", "red"] },
      { type: "shape", target: "diamond", options: ["square", "hexagon", "diamond", "triangle"] },
      { type: "color", target: "orange", options: ["orange", "yellow", "red", "pink"] },
    ],
  },
  {
    id: 7,
    name: "Pelangi Warna",
    icon: "\uD83C\uDF08",
    color: "#EC4899",
    desc: "Cocokkan urutan warna pelangi!",
    type: "match_color",
    questions: [
      { targets: ["red", "orange", "yellow"], pool: ["red", "orange", "yellow", "green", "blue"] },
      { targets: ["green", "blue", "purple"], pool: ["green", "blue", "purple", "yellow", "pink"] },
      { targets: ["red", "yellow", "blue"], pool: ["red", "yellow", "blue", "green", "purple"] },
      { targets: ["orange", "green", "pink", "purple"], pool: ["orange", "green", "pink", "purple", "cyan", "red"] },
      { targets: ["cyan", "red", "yellow", "blue"], pool: ["cyan", "red", "yellow", "blue", "green", "orange"] },
    ],
  },
  {
    id: 8,
    name: "Bentuk Lanjutan",
    icon: "\u2728",
    color: "#7C3AED",
    desc: "Cocokkan bentuk yang lebih banyak!",
    type: "match_shape",
    questions: [
      { targets: ["heart", "star", "diamond", "hexagon"], pool: ["heart", "star", "diamond", "hexagon", "circle", "triangle"] },
      { targets: ["oval", "circle", "hexagon", "star"], pool: ["oval", "circle", "hexagon", "star", "diamond", "heart"] },
      { targets: ["square", "triangle", "diamond", "hexagon", "star"], pool: ["square", "triangle", "diamond", "hexagon", "star", "circle", "heart"] },
      { targets: ["circle", "oval", "diamond", "square"], pool: ["circle", "oval", "diamond", "square", "triangle", "heart"] },
      { targets: ["star", "heart", "hexagon", "oval", "triangle"], pool: ["star", "heart", "hexagon", "oval", "triangle", "diamond", "circle"] },
    ],
  },
  {
    id: 9,
    name: "Bangun Hewan",
    icon: "\uD83D\uDC2C",
    color: "#06B6D4",
    desc: "Susun gambar hewan dari balok!",
    type: "build_picture",
    questions: [
      {
        name: "Ikan", gridSize: 3, pieces: [
          { pos: [0,0], color: "#06B6D4", label: "\uD83C\uDF0A" },
          { pos: [0,1], color: "#3B82F6", label: "\uD83D\uDC1F" },
          { pos: [0,2], color: "#06B6D4", label: "\uD83C\uDF0A" },
          { pos: [1,0], color: "#3B82F6", label: "\uD83D\uDC1F" },
          { pos: [1,1], color: "#EC4899", label: "\u2764\uFE0F" },
          { pos: [1,2], color: "#3B82F6", label: "\uD83D\uDC1F" },
          { pos: [2,0], color: "#06B6D4", label: "\uD83C\uDF0A" },
          { pos: [2,1], color: "#3B82F6", label: "\uD83D\uDC1F" },
          { pos: [2,2], color: "#06B6D4", label: "\uD83C\uDF0A" },
        ],
      },
      {
        name: "Kucing", gridSize: 3, pieces: [
          { pos: [0,0], color: "#F59E0B", label: "\uD83D\uDC42" },
          { pos: [0,1], color: "#FCD34D", label: "\uD83D\uDC31" },
          { pos: [0,2], color: "#F59E0B", label: "\uD83D\uDC42" },
          { pos: [1,0], color: "#FCD34D", label: "\u2728" },
          { pos: [1,1], color: "#EF4444", label: "\uD83D\uDC44" },
          { pos: [1,2], color: "#FCD34D", label: "\u2728" },
          { pos: [2,0], color: "#FCD34D", label: "\uD83D\uDC3E" },
          { pos: [2,1], color: "#F59E0B", label: "\uD83C\uDF80" },
          { pos: [2,2], color: "#FCD34D", label: "\uD83D\uDC3E" },
        ],
      },
      {
        name: "Burung", gridSize: 3, pieces: [
          { pos: [0,0], color: "#3B82F6", label: "\u2601\uFE0F" },
          { pos: [0,1], color: "#FBBF24", label: "\uD83C\uDF1F" },
          { pos: [0,2], color: "#3B82F6", label: "\u2601\uFE0F" },
          { pos: [1,0], color: "#A855F7", label: "\uD83E\uDEB6" },
          { pos: [1,1], color: "#EC4899", label: "\uD83D\uDC26" },
          { pos: [1,2], color: "#A855F7", label: "\uD83E\uDEB6" },
          { pos: [2,0], color: "#22C55E", label: "\uD83C\uDF3F" },
          { pos: [2,1], color: "#16A34A", label: "\uD83C\uDF33" },
          { pos: [2,2], color: "#22C55E", label: "\uD83C\uDF3F" },
        ],
      },
    ],
  },
  {
    id: 10,
    name: "Super Tantangan",
    icon: "\uD83C\uDFC6",
    color: "#DC2626",
    desc: "Mode tercepat - kombinasi semua tipe!",
    type: "speed",
    timePerQuestion: 10,
    questions: [
      { type: "shape", target: "hexagon", options: ["hexagon", "circle", "diamond", "star"] },
      { type: "color", target: "cyan", options: ["cyan", "blue", "purple", "pink"] },
      { type: "shape", target: "oval", options: ["oval", "circle", "diamond", "square"] },
      { type: "color", target: "pink", options: ["pink", "purple", "red", "orange"] },
      { type: "shape", target: "diamond", options: ["square", "diamond", "triangle", "hexagon"] },
      { type: "color", target: "yellow", options: ["yellow", "orange", "green", "red"] },
      { type: "shape", target: "heart", options: ["heart", "star", "circle", "oval"] },
      { type: "color", target: "purple", options: ["purple", "pink", "blue", "red"] },
      { type: "shape", target: "star", options: ["star", "diamond", "hexagon", "heart"] },
      { type: "color", target: "green", options: ["green", "yellow", "cyan", "blue"] },
      { type: "shape", target: "triangle", options: ["triangle", "diamond", "square", "star"] },
      { type: "color", target: "red", options: ["red", "orange", "pink", "purple"] },
    ],
  },
];

// Shuffle utility
export const shuffleArray = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// Sound effects
export const playPlaceSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.frequency.setValueAtTime(800, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(1200, ctx.currentTime + 0.08);
    gain.gain.setValueAtTime(0.12, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);
    osc.start(); osc.stop(ctx.currentTime + 0.15);
  } catch (err) { logger.debug("audio/data op failed", err); }
};

export const playWrongBlockSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.type = "sawtooth";
    osc.frequency.setValueAtTime(250, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(120, ctx.currentTime + 0.25);
    gain.gain.setValueAtTime(0.08, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.25);
    osc.start(); osc.stop(ctx.currentTime + 0.25);
  } catch (err) { logger.debug("audio/data op failed", err); }
};

export const playLevelCompleteSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [523, 659, 784, 1047].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination);
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.1, ctx.currentTime + i * 0.1);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.1 + 0.2);
      osc.start(ctx.currentTime + i * 0.1);
      osc.stop(ctx.currentTime + i * 0.1 + 0.2);
    });
  } catch (err) { logger.debug("audio/data op failed", err); }
};

export const speakBlockMission = (text) => {
  try {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(text);
      u.lang = getVoiceLang(); u.rate = 0.85; u.pitch = 1.0;
      window.speechSynthesis.speak(u);
    }
  } catch (err) { logger.debug("audio/data op failed", err); }
};
